import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '../../lib/api';
import type { BreadcrumbItem } from './types';

/**
 * 可复用面包屑组件（§48）："华南一号仓 › 一区 › 冷藏间 1 › 货架 3"，每级可
 * 点击跳转。后续里程碑（库存浏览器、搜索结果等）直接复用，不需要重新实现
 * 路径拼接逻辑。
 */
export function LocationBreadcrumb({
  locationId,
  onNavigate,
}: {
  readonly locationId: string;
  readonly onNavigate: (id: string) => void;
}): React.JSX.Element | null {
  const { data } = useQuery({
    queryKey: ['locations', locationId, 'path'],
    queryFn: () => apiFetch<{ items: BreadcrumbItem[] }>(`/locations/${locationId}/path`),
  });

  if (!data) return null;
  const items = data.items;

  return (
    <nav className="breadcrumb" aria-label="location path">
      {items.map((item, i) => {
        const isLast = i === items.length - 1;
        return (
          <span key={item.id}>
            {i > 0 && <span className="breadcrumb__sep">›</span>}
            {isLast ? (
              <span className="breadcrumb__current">{item.name}</span>
            ) : (
              <button
                type="button"
                className="breadcrumb__link"
                onClick={() => onNavigate(item.id)}
              >
                {item.name}
              </button>
            )}
          </span>
        );
      })}
    </nav>
  );
}
